import {SelectOption} from "./CommonUIElementTypes";

interface RoutesType {
    [index: string]: {
        label: string;
        pathSegment: string;
    };
}

let routes: RoutesType = {
    dashboard: {
        label: 'Dashboard',
        pathSegment: 'dashboard'
    },
    dispatch: {
        label: 'Dispatch',
        pathSegment: 'dispatch'
    },
    brokerReports: {
        label: 'Broker Reports',
        pathSegment: 'broker-reports'
    },
    jobs: {
        label: 'Jobs',
        pathSegment: 'jobs'
    },
    brokers: {
        label: 'Brokers',
        pathSegment: 'brokers'
    },
    users: {
        label: 'Users',
        pathSegment: 'users'
    },
    myAccount: {
        label: 'My Account',
        pathSegment: 'my-account'
    },
    settings: {
        label: 'Settings',
        pathSegment: 'settings'
    },
}
let yesOption = {label: 'Yes', value: true}
let noOption = {label: 'No', value: false}
let yesNoSelectOptions = [yesOption, noOption]

let sortDirections = {
    asc: 'asc',
    desc: 'desc',
}
let sortAscendingOption = {label: 'Ascending (A to Z)', value: sortDirections.asc}
let sortDescendingOption = {label: 'Descending (Z to A)', value: sortDirections.desc}
let listSortOptions: SelectOption[] = [sortAscendingOption, sortDescendingOption]
let jobsListSortOptions: SelectOption[] = [
    {label: 'By Job Number (Ascending)', value: sortDirections.asc},
    {label: 'By Job Number (Descending)', value: sortDirections.desc}
]

export let Constants = {
    routes: routes,
    permissionNames: {
        canAccessWebAdmin: 'Can Access Web Admin',
        userCreate: 'User Create',
        userUpdate: 'User Update',
        jobUpdate: 'Job Update',
        noActivityReportDelete: 'No Activity Report Delete',
        activityScopeCreate: 'Activity Scope Create',
        activityScopeUpdate: 'Activity Scope Update',
        activityMaterialCreate: 'Activity Material Create',
        activityMaterialUpdate: 'Activity Material Update',
    },

    activityDirectionNames: {
        inbound: "Inbound",
        outbound: "Outbound"
    },

    dispatchOrderStatusNames: {
        requested: "Requested",
        pending: "In Process",
        confirmed: "Confirmed",
        cancelled: "Cancelled"
    },

    brokerReportShareTypeNames: {
        linkCreated: "Link Created",
        print: "Plan Printed",
        sms: "SMS Shared",
        email: "Email Shared"
    },

    railsEnvironments: {
        development: 'development',
        e2e_test: 'e2e_test',
        production: 'production'
    },

    defaultPageNumber: 1,
    defaultPageCount: 1,
    searchDelayMs: 1000,
    debounceTimeoutMs: 400,
    loadingIndicatorSrc: '/static/images/loading-on-white.gif',
    loadingIndicatorOnGraySrc: '/static/images/loading-white-on-gray.gif',
    sortDirections: sortDirections,
    minPasswordLength: 8,
    passwordPlaceholder: "********",
    dispatchOrderMessageAdditionalConfig: {offset: {y: 61}},
    yesOption: yesOption,
    noOption: noOption,
    yesNoSelectOptions: yesNoSelectOptions,

    sortAscendingOption: sortAscendingOption,
    sortDescendingOption: sortDescendingOption,
    listSortOptions: listSortOptions,
    jobsListSortOptions: jobsListSortOptions
};
